import React from 'react';


import {CountrySelect} from '../../../contexts/Geo';

import FormFieldError from '../FormFieldError';
import FormElement from '../FormElement';


function FormCountrySelect(props) {

    return (
        <FormElement {...props}>
            <CountrySelect {...props}/>
            <FormFieldError error={props.error}/>
        </FormElement>
    );
}


FormCountrySelect.propTypes = {
    ...FormElement.propTypes,
    ...CountrySelect.propTypes
};

FormCountrySelect.defaultProps = {
    ...FormElement.defaultProps,
    ...CountrySelect.defaultProps
};


export default FormCountrySelect;
